import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateSupplierContactController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import TitleService from "../../../Setup/controller/TitleController/TitleController";
import Draggable from 'react-draggable';
import SendEmail from "../../../Common/SendEmail";
function CreateSupplierContact({ modalInstance, currentSupplierContact, onClose, onSuccess, SupplierList, SupplierID }) {

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [TitleList, setTitles] = useState([]);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [formData, setFormData] = useState({
        FK_Supplier_ID: SupplierID, vc_Title: "Mr", vc_FirstName: '', vc_SurName: '',
        vc_Email: '', vc_Occupation: '', vc_Username: '', vc_Password: ''
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const fetchTitle = async () => {
        try {
            const listOfTitles = await TitleService.GetAllTitle();
            setTitles(listOfTitles);
            if (listOfTitles.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    Title: listOfTitles[0].Title, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    useEffect(() => {
        fetchTitle();
        if (currentSupplierContact) {
            setFormData({
                FK_Supplier_ID: SupplierID, vc_Title: currentSupplierContact.vc_Title,
                vc_FirstName: currentSupplierContact.vc_FirstName, vc_SurName: currentSupplierContact.vc_SurName,
                vc_Email: currentSupplierContact.vc_Email, vc_Occupation: currentSupplierContact.vc_Occupation,
                vc_Username: currentSupplierContact.vc_Username, vc_Password: currentSupplierContact.vc_Password
            });
        } else {
            setFormData({
                FK_Supplier_ID: SupplierID, vc_Title: "Mr", vc_FirstName: '', vc_SurName: '',
                vc_Email: '', vc_Occupation: '', vc_Username: '', vc_Password: ''
            }); // Clear form data when switching to add mode
        }
    }, [currentSupplierContact]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission

        if (currentSupplierContact) {
            formData.PK_SupplierContact_ID = currentSupplierContact.PK_SupplierContact_ID;
        } else {
            formData.PK_SupplierContact_ID = 0;
        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data            
        }, () => {
            onSuccess(); // Call onSuccess to reload data            
        });
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleEmailClick = async (event, email) => {
        event.stopPropagation();
        setEmail(email)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade supplierContactModal show d-block" id="supplierContactModal" tabIndex="-1" aria-labelledby="supplierContactModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">

                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentSupplierContact ? "Edit Contact" : "Add Contact"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginLeft: "-5px",marginRight:"0px" }}>
                                        <div className="col-sm-12">
                                            <table style={{ width: "100%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ width: "13%" }}><label htmlFor="vc_Title" style={{ float: "right" }}>Title <span style={{ "color": "red" }}>*</span></label></td>
                                                        <td style={{ width: "37%" }}>

                                                            <select name="vc_Title" className='form-control' value={formData.vc_Title} onChange={handleFieldChange}>
                                                                {TitleList.map((title) => (
                                                                    <option key={title.Title} value={title.Title}>
                                                                        {title.Title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.vc_Title && <div style={{ color: 'red' }}>{errors.vc_Title}</div>}
                                                        </td>
                                                        <td style={{ width: "13%" }}><label htmlFor="vc_FirstName" style={{ float: "right" }}>First Name <span style={{ "color": "red" }}>*</span></label></td>
                                                        <td style={{ width: "37%" }}>
                                                            <input type="text" className="form-control" name="vc_FirstName" value={formData.vc_FirstName} onChange={handleFieldChange} />
                                                            {errors.vc_FirstName && <div style={{ color: 'red' }}>{errors.vc_FirstName}</div>}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><label htmlFor="vc_SurName" style={{ float: "right" }}>Last Name <span style={{ "color": "red" }}>*</span></label></td>
                                                        <td>
                                                            <input type="text" className="form-control" name="vc_SurName" value={formData.vc_SurName} onChange={handleFieldChange} />
                                                            {errors.vc_SurName && <div style={{ color: 'red' }}>{errors.vc_SurName}</div>}
                                                        </td>
                                                        <td><label htmlFor="Email" style={{ float: "right" }}>Email <span style={{ "color": "red" }}>*</span></label></td>
                                                        <td>
                                                            <table style={{ width: "100%" }}>
                                                                <tr>
                                                                <td style={{width:"85%"}}>
                                                                    <input type="text" className="form-control" name="vc_Email" value={formData.vc_Email} onChange={handleFieldChange} />
                                                                    {errors.vc_Email && <div style={{ color: 'red' }}>{errors.vc_Email}</div>}
                                                                </td>
                                                                <td style={{width:"15%"}}>
                                                                        {currentSupplierContact && (formData.vc_Email != "" && formData.vc_Email != null && formData.vc_Email != "undefined") && (

                                                                            <a href='#' onClick={(event) => handleEmailClick(event, formData.vc_Email)}>
                                                                                <img src="assets/img/resources/email-icon.png" class="top-icon" alt="Add icon" style={{ height: "22px" }} />
                                                                            </a>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>


                                                        <td><label htmlFor="vc_Occupation" style={{ float: "right" }}>Occupation &nbsp;&nbsp;</label></td>
                                                        <td>
                                                            <input type="text" className="form-control" name="vc_Occupation" value={formData.vc_Occupation} onChange={handleFieldChange} />
                                                            {errors.vc_Occupation && <div style={{ color: 'red' }}>{errors.vc_Occupation}</div>}
                                                        </td>
                                                        <td><label htmlFor="vc_Username" style={{ float: "right" }}>User Name &nbsp;&nbsp;</label></td>
                                                        <td>
                                                            <input type="text" className="form-control" name="vc_Username" value={formData.vc_Username} onChange={handleFieldChange} />
                                                            {errors.vc_Username && <div style={{ color: 'red' }}>{errors.vc_Username}</div>}
                                                        </td>
                                                    </tr>

                                                    <tr>

                                                        <td><label htmlFor="vc_Password" style={{ float: "right" }}>Password &nbsp;&nbsp;</label></td>
                                                        <td>
                                                            <input type="text" className="form-control" name="vc_Password" value={formData.vc_Password} onChange={handleFieldChange} />
                                                            {errors.vc_Password && <div style={{ color: 'red' }}>{errors.vc_Password}</div>}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                       <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />    
                                            {currentSupplierContact ? " Update" : " Save"}
                                    
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} />
            )}
        </div>
    );
}
export default CreateSupplierContact;